import React, { type SVGProps } from 'react';

import { SvgLoading } from './Loading';

export function AnimatedLoading(props: SVGProps<SVGSVGElement>) {
  return (
    <span
      className="animation-loading"
    >
      <SvgLoading {...props} />
    </span>
  );
}
